// extracted by mini-css-extract-plugin
export default {"submitWrapper":"StopFactors_submitWrapper__+qTYC"};